import React, { useEffect } from 'react'
import { Skeleton } from '@mui/material'

import { AppDataTable } from '@components'
import BatchDateFilter from './dateFilter'
import { createdColumn, historyColumn, idColumn, numSearchesColumn, officesColumn, sitesColumn } from './columns'
import { useBatchTableInfo, useManageBatchStatus } from '../@hooks'
import { batchListData } from 'Pages/Batch/Page/@signals'
import ExecutionToolbarSelect from "./Toolbar";
import { isTourDemoActive } from '@signals/app'


export default function BatchTable() {
	const { isLoading, setDateFilter, dateFilter } = useBatchTableInfo()
	useManageBatchStatus()

	useEffect(() => {
		setDateFilter()
	}, [])

	if (isTourDemoActive.value && !batchListData.value?.length && !isLoading.value) return null

	return isLoading.value
		? <Skeleton variant="rectangular" height={700}/>
		: <AppDataTable
			title="Batch List"
			toolbarProps={{ actions: false }}
			data={batchListData.value}
			columns={[
				idColumn(),
				...sitesColumn(),
				...officesColumn(),
				numSearchesColumn(),
				...createdColumn(),
				historyColumn(),
			]}
			options={{
				selectableRows: 'multiple',
				customToolbarSelect: (selectedData, setSelectedRows) => <ExecutionToolbarSelect
					selectedData={selectedData}
					setSelectedRows={setSelectedRows}/>,
				customToolbar: () => <BatchDateFilter value={dateFilter.value} onChange={setDateFilter}/>,
			}}
			setHeaderCellProps={() => ({ sx: { fontWeight: 'bold' } })}
			setBodyCellProps={() => ({ sx: { width: 250 } })}
		/>
}